import { lazy } from 'react';
import { overviewRoutes } from './overviewRoutes';
const Overview = lazy(() => import('../overviewPage'));

const PeerAnalysis = lazy(() => import('../pages/peerAnalysisModel/PeerAnalysis'));

const HighestAndLowestPercentileRankedMeasures = lazy(() =>
  import('../pages/peerAnalysisModel/HighestAndLowestPercentileRankedMeasures')
);

const MeasureAnalysisTrendPerformanceVsPeers = lazy(() =>
  import('../pages/peerAnalysisModel/MeasureAnalysisTrendPerformanceVsPeers')
);

const PeerGroupAttributeSelection = lazy(() => import('../pages/peerAnalysisModel/PeerGroupAttributeSelection'));

const PercentileRankingAnalysis = lazy(() => import('../pages/peerAnalysisModel/PercentileRankingAnalysis'));

const StarsCurrentYearIndustryOverview = lazy(() =>
  import('../pages/peerAnalysisModel/StarsCurrentYearIndustryOverview')
);

const SummaryTrendPerformanceVsPeers = lazy(() => import('../pages/peerAnalysisModel/SummaryTrendPerformanceVsPeers'));

const ChangeFromStarsThroughPreviousToCurrentYears = lazy(() =>
  import(
    '../pages/peerAnalysisModel/changeFromStarsThroughPreviousToCurrentYears/ChangeFromStarsThroughPreviousToCurrentYears'
  )
);

const ScorecardDirectory = lazy(() => import('../scorecardDirectory'));
const ScoreChanges = lazy(() => import('../pages/peerAnalysisModel/ScoreChanges'));
const WeightChangeImpact = lazy(() => import('../pages/peerAnalysisModel/WeightChangeImpact'));
const DecliningMeasures = lazy(() => import('../pages/peerAnalysisModel/DecliningMeasures'));
const SpecificMeasureTrendAnalysis = lazy(() => import('../pages/peerAnalysisModel/SpecificMeasureTrendAnalysis'));
const PeerAnalysisCutpointProximity = lazy(() =>
  import('../pages/peerAnalysisModel/peerAnalysisCutpointProximity/PeerAnalysisCutpointProximity')
);

const MeasureRankingAnalysis = lazy(() => import('../pages/peerAnalysisModel/MeasureRankingAnalysis'));

//named 'plus' as a product type/package
export const starsMonitorPeerAnalysisRoutes = [
  {
    path: '/',
    component: Overview,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/directory',
    component: ScorecardDirectory,
    menuType: 'peerAnalysisModel',
  },
  {
    path: '/peerGroupAttributeSelection',
    component: PeerGroupAttributeSelection,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/summaryTrendPerformanceVsPeers',
    component: SummaryTrendPerformanceVsPeers,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/measureAnalysisTrendPerformanceVsPeers',
    component: MeasureAnalysisTrendPerformanceVsPeers,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/changeFromStarsThroughPreviousToCurrentYears',
    component: ChangeFromStarsThroughPreviousToCurrentYears,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/peerAnalysis',
    component: PeerAnalysis,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/highestAndLowestPercentileRankedMeasures',
    component: HighestAndLowestPercentileRankedMeasures,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/percentileRankingAnalysis',
    component: PercentileRankingAnalysis,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/starsCurrentYearIndustryOverview',
    component: StarsCurrentYearIndustryOverview,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/scoreChanges',
    component: ScoreChanges,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/weightChangeImpact',
    component: WeightChangeImpact,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/specificMeasureTrendAnalysis',
    component: SpecificMeasureTrendAnalysis,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/decliningMeasures',
    component: DecliningMeasures,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/peerAnalysisCutpointProximity',
    component: PeerAnalysisCutpointProximity,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
  {
    path: '/measureRankingAnalysis',
    component: MeasureRankingAnalysis,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },

  ...overviewRoutes,
  {
    //catch all
    path: '*',
    component: Overview,
    menuType: 'peerAnalysisModel',
    listName: 'peerAnalysisModel',
  },
];
